import React, { useCallback } from 'react';

import { SuccessFullScreen } from '@betterment/samba-react';

import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

export const Success: React.FC = () => {
  const complete = useCallback(() => {
    locationAssign(urlBuilder.getAppRoot());
  }, []);

  return <SuccessFullScreen message="Nice job, you’ve confirmed your account!" onCompletion={complete} />;
};
